module.exports = __webpack_public_path__ + "static/img/icon-user.ac25e28c.svg";